import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { CloudAssetOrigin, OnPremAssetOrigin } from "../../../common/types/AssetOrigin";
import { AssetType } from "../../../common/types/AssetType";
import { AssetItem } from "../../list/common/AssetItem";

export const renderAssetOrigin = (
    item?: AssetItem,
    _index?: number,
    column?: ListTableColumn<AssetItem>
): ReactElement | null => {
    if (item?.assetType === AssetType.Cloud) {
        return renderEnumValue(CloudAssetOrigin, item, _index, column);
    }

    if (item?.assetType === AssetType.OnPrem) {
        return renderEnumValue(OnPremAssetOrigin, item, _index, column);
    }

    throw new Error("Unsupported asset type");
};
